"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.Theme = exports.Location = exports.LinkCtaPropType = exports.InputMessage = exports.ImagePropType = exports.FeaturePropType = exports.Distance = exports.Dealer = exports.Data = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var Dealer = _propTypes["default"].shape({});
exports.Dealer = Dealer;
var Distance = _propTypes["default"].shape({
  shortName: _propTypes["default"].string,
  longName: _propTypes["default"].string
});
exports.Distance = Distance;
var Location = _propTypes["default"].shape({
  lat: _propTypes["default"].number,
  lng: _propTypes["default"].number
});
exports.Location = Location;
var ImagePropType = _propTypes["default"].shape({
  image: _propTypes["default"].string,
  altText: _propTypes["default"].string
});
exports.ImagePropType = ImagePropType;
var LinkCtaPropType = _propTypes["default"].shape({
  URL: _propTypes["default"].string,
  label: _propTypes["default"].string
});
exports.LinkCtaPropType = LinkCtaPropType;
var FeaturePropType = _propTypes["default"].shape({
  image: ImagePropType,
  description: _propTypes["default"].string
});
exports.FeaturePropType = FeaturePropType;
var Data = _propTypes["default"].shape({
  apiKey: _propTypes["default"].string,
  resourceType: _propTypes["default"].string,
  locationCtaLabel: _propTypes["default"].string,
  radius: _propTypes["default"].number,
  preSelectedFilter: _propTypes["default"].oneOf(['services', 'sales']),
  metricSystem: _propTypes["default"].string,
  title: _propTypes["default"].string,
  searchFieldLabel: _propTypes["default"].string,
  searchHelpText: _propTypes["default"].string,
  viewMoreText: _propTypes["default"].string,
  noGeolocationMessage: _propTypes["default"].string,
  invalidZipCodeMessage: _propTypes["default"].string,
  enableTheSearchPostcode: _propTypes["default"].bool
});
exports.Data = Data;
var InputMessage = _propTypes["default"].shape({
  body: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(['error', 'info'])
});
exports.InputMessage = InputMessage;
var Theme = _propTypes["default"].objectOf(_propTypes["default"].string).isRequired;
exports.Theme = Theme;